/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/*
 * WinnerBanner.jsx
 * Created by Destin Frasier on 12/10/20
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'sarsaparilla';

export default function WinnerBanner({ winnerType, year }) {
    function WinnerBlock(name) {
        const Partners = {
            grandPrize: {
                trophyColor: 'grand-prize',
                prizeLevel: 'Grand Prize',
                place: '1st Place',
                category: null,
            },
            grandPrize2: {
                trophyColor: 'grand-prize',
                prizeLevel: 'Grand Prize',
                place: '2nd Place',
                category: null,
            },
            grandPrize3: {
                trophyColor: 'grand-prize',
                prizeLevel: 'Grand Prize',
                place: '3rd Place',
                category: null,
            },

            ///
            categoryWinnerTraditions: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Winner',
                place: null,
                category: 'Traditions (Old and New)',
            },
            categoryRunnerTraditions: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Runner-up',
                place: null,
                category: 'Traditions (Old and New)',
            },

            ///
            categoryWinnerReflectionJourneys: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Winner',
                place: null,
                category: 'Reflection Journeys',
            },
            categoryRunnerReflectionJourneys: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Runner-up',
                place: null,
                category: 'Reflection Journeys',
            },

            ///
            categoryWinnerCampervans: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Winner',
                place: null,
                category: 'RV / Campervans',
            },
            categoryRunnerCampervans: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Runner-up',
                place: null,
                category: 'RV / Campervans',
            },

            ///
            categoryWinnerGroupTravel: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Winner',
                place: null,
                category: 'Family or Group Travel',
            },
            categoryRunnerGroupTravel: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Runner-up',
                place: null,
                category: 'Family or Group Travel',
            },

            ///
            categoryWinnerActivitiesAdventure: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Winner',
                place: null,
                category: 'Activities & Adventure',
            },
            categoryRunnerActivitiesAdventure: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Runner-up',
                place: null,
                category: 'Activities & Adventure',
            },

            ///
            categoryWinnerBestTimeEver: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Winner',
                place: null,
                category: 'Best Time Ever!',
            },
            categoryRunnerBestTimeEver: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Runner-up',
                place: null,
                category: 'Best Time Ever!',
            },

            ///
            categoryWinnerReachingStars: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Winner',
                place: null,
                category: 'Reaching for the Stars',
            },
            categoryRunnerReachingStars: {
                trophyColor: 'category-prize',
                prizeLevel: 'Category Runner-up',
                place: null,
                category: 'Reaching for the Stars',
            },

            /// Monthly Winners
            monthlyWinnerJan: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'January',
            },
            monthlyRunnerJan: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'January',
            },
            monthlyFinalistJan: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'January',
            },
            // need to include this twice because its currently called monthlyFinalistJan in SNOW
            monthlyTopTenJan: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'January',
            },

            ///
            monthlyWinnerFeb: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'February',
            },
            monthlyRunnerFeb: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'February',
            },
            monthlyTopTenFeb: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'February',
            },

            ///
            monthlyWinnerMar: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'March',
            },
            monthlyRunnerMar: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'March',
            },
            monthlyTopTenMar: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'March',
            },

            ///
            monthlyWinnerApril: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'April',
            },
            monthlyRunnerApril: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'April',
            },
            monthlyTopTenApril: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'April',
            },

            ///
            monthlyWinnerMay: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'May',
            },
            monthlyRunnerMay: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'May',
            },
            monthlyTopTenMay: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'May',
            },

            ///
            monthlyWinnerJun: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'June',
            },
            monthlyRunnerJun: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'June',
            },
            monthlyTopTenJun: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'June',
            },

            ///
            monthlyWinnerJul: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'July',
            },
            monthlyRunnerJul: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'July',
            },
            monthlyTopTenJul: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'July',
            },

            ///
            monthlyWinnerAug: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'August',
            },
            monthlyRunnerAug: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'August',
            },
            monthlyTopTenAug: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'August',
            },

            ///
            monthlyWinnerSept: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'September',
            },
            monthlyRunnerSept: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'September',
            },
            monthlyTopTenSept: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'September',
            },

            ///
            monthlyWinnerOct: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'October',
            },
            monthlyRunnerOct: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'October',
            },
            monthlyTopTenOct: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'October',
            },

            ///
            monthlyWinnerNov: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'November',
            },
            monthlyRunnerNov: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'November',
            },
            monthlyTopTenNov: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'November',
            },

            ///
            monthlyWinnerDec: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Winner',
                place: null,
                category: 'December',
            },
            monthlyRunnerDec: {
                trophyColor: 'monthly-prize',
                prizeLevel: 'Monthly Runner-up',
                place: null,
                category: 'December',
            },
            monthlyTopTenDec: {
                trophyColor: 'top-ten',
                prizeLevel: 'Monthly Top Ten',
                place: null,
                category: 'December',
            },

            ///
            honorableMention: {
                trophyColor: 'honorable-mention-prize',
                prizeLevel: 'Honorable Mention',
                place: null,
                category: null,
            },
            none: '',
        };

        return Partners[name] || Partners.none;
    }

    const agencyInfo = WinnerBlock(winnerType?.name);

    return (
        <div className="ugc-story-winner-banner">
            <span className="ugc-story-winner-trophy">
                <Icon
                    iconName="trophy"
                    className={`ugc-story-${agencyInfo.trophyColor}`}
                />
            </span>
            {year} {agencyInfo.prizeLevel}{' '}
            {agencyInfo.prizeLevel === 'Honorable Mention' ? '' : '-'}
            <strong className="ml-half">
                {agencyInfo.place}
                {agencyInfo.category}
            </strong>
            {agencyInfo.name}
        </div>
    );
}

WinnerBanner.propTypes = {
    year: PropTypes.string,
    winnerType: PropTypes.oneOf([
        '',
        'grandPrize',
        'grandPrize2',
        'grandPrize3',
        'categoryWinnerTraditions',
        'categoryRunnerTraditions',
        'categoryWinnerReflectionJourneys',
        'categoryRunnerReflectionJourneys',
        'categoryWinnerCampervans',
        'categoryRunnerCampervans',
        'categoryWinnerGroupTravel',
        'categoryRunnerGroupTravel',
        'categoryWinnerActivitiesAdventure',
        'categoryRunnerActivitiesAdventure',
        'categoryWinnerBestTimeEver',
        'categoryRunnerBestTimeEver',
        'monthlyWinnerJan',
        'monthlyRunnerJan',
        'monthlyFinalistJan',
        'monthlyTopTenJan',
        'monthlyWinnerFeb',
        'monthlyRunnerFeb',
        'monthlyFinalistFeb',
        'monthlyTopTenFeb',
        'monthlyWinnerMar',
        'monthlyRunnerMar',
        'monthlyFinalistMar',
        'monthlyTopTenMar',
        'monthlyWinnerApril',
        'monthlyRunnerApril',
        'monthlyFinalistApril',
        'monthlyTopTenApril',
        'monthlyTopTenMay',
        'monthlyTopTenJun',
        'monthlyTopTenJul',
        'monthlyTopTenAug',
        'monthlyTopTenSept',
        'monthlyTopTenOct',
        'monthlyTopTenNov',
        'monthlyTopTenDec',
        'honorableMention',
    ]),
};
